import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts/highcharts';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsMore from "highcharts/highcharts-more";
import {SolidgaugeChartService} from "../../../services/solidgauge-chart/solidgauge-chart.service";""
import { Options } from 'highcharts';
import { InsightsService } from 'src/app/services/insights/insights.service';
import moment from 'moment';
import {PermissionsService} from "../../../services/permissions/permissions.service";

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-insights-department-performance',
  templateUrl: './insights-department-performance.component.pug',
  styleUrls: ['./insights-department-performance.component.scss'],
  standalone: false
})
export class InsightsDepartmentPerformanceComponent implements OnInit, OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  contractCompletion = 20
  contractCompletionChartOptions:{} = [];
  expansionText = $localize`Show more`
  expanded = false;
  @Input() start:any;
  @Input() end:any;
  @Input() request: any;
  @Input() survey: any;
  @Input() department: any;
  @Input() filterBy!: any;
  departmentScores: any[] = [];
  hideSection = false;
  ENT_10363_PULSE_RELAUNCH = false;

  constructor(private insightsService: InsightsService,
              private permissions: PermissionsService) {
  }
  ngOnInit(): void {
    this.ENT_10363_PULSE_RELAUNCH = this.permissions.isFeatureActivated('ENT-10363-pulse-relaunch');
  }

  setPulseDepartmentScores(start, end) {
    if (!start) {
      start = moment('1970-01-01T00:00:00.000');
    }
    if(!end) {
      end = moment(new Date());
    }
    this.insightsService.getPulseDepartmentPerformanceScores(start, end, this.request, this.department, this.survey).subscribe(
      res => {
        this.departmentScores = res;
        if (this.departmentScores.length < 2) {
          this.hideSection = true;
        } else {
          this.hideSection = false;
        }
        this.departmentScores.sort((a, b) => b.value - a.value);
        this.departmentScores = this.departmentScores.map(item => {
          return {
            ...item,
            value: ((((item.value-1)*9)/4)+1).toFixed(1)
          };
        });
        for (let i=0; i<this.departmentScores.length; i++) {
          if(this.departmentScores[i].value>6) {
            this.contractCompletionChartOptions[i] = SolidgaugeChartService.getOptionsDepartment(this.departmentScores[i].value*10, '#32735F', 'rgb(244,248,247)');
          }
          else if (this.departmentScores[i].value>=4 && this.departmentScores[i].value<=6) {
            this.contractCompletionChartOptions[i] = SolidgaugeChartService.getOptionsDepartment(this.departmentScores[i].value*10, '#D18400', '#FBF2E5');
          }
          else if (this.departmentScores[i].value<4) {
            this.contractCompletionChartOptions[i] = SolidgaugeChartService.getOptionsDepartment(this.departmentScores[i].value*10, '#AF0000', '#F7E5E5');
          }
        }
      }
    )
  }

  showMore() {
    let doc = document.getElementById('performance-blocks')
    this.expanded = !this.expanded
    if(this.expanded && doc) {
      this.expansionText = $localize`Show less`
      doc.classList.add('performance-blocks-expanded')
      doc.classList.remove('performance-blocks-collapsed')
    }
    else {
      this.expansionText = $localize`Show more`
      doc?.classList.remove('performance-blocks-expanded')
      doc?.classList.add('performance-blocks-collapsed')
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setPulseDepartmentScores(this.start, this.end);
  }

  setContractOptions(index) {
    return SolidgaugeChartService.getOptionsDepartment(this.contractCompletion, '#32735F', 'rgb(244,248,247)');
  }

  getOptions(y_value: number, color: string, backgroundColor: string): Options {
    return SolidgaugeChartService.getOptions(y_value, color, backgroundColor);
  }
}
